/* CDS — Personnalisation produit (externalisé depuis cds-page-produit.liquid) */
(function () {
  function initCdsPerso(section) {

  var perso = section.querySelector('.cds-pp__perso');
  if (!perso) return;
  var _sid = (section.id || '').replace('cds-pp-', '');

  var LABELS = {
    type: perso.getAttribute('data-label-type') || 'Type',
    couleur: perso.getAttribute('data-label-couleur') || 'Numéro de couleur',
    forme: perso.getAttribute('data-label-forme') || 'Forme',
    longueur: perso.getAttribute('data-label-longueur') || 'Longueur',
    mesures_connues: perso.getAttribute('data-label-mesures-connues') || 'Connaît ses mesures',
    mesures: perso.getAttribute('data-label-mesures') || 'Mesures',
    commentaire: perso.getAttribute('data-label-commentaire') || 'Commentaire'
  };
  var SUPPLEMENT_HANDLE = perso.getAttribute('data-supplement-handle') || '';
  var TYPE2_VALUE = perso.getAttribute('data-type2-value') || 'Prêt-à-porter';
  var supplementCache = null;
  /* Variant ID du supplément pré-résolu en Liquid (évite tout fetch /products) */
  var SUPPLEMENT_VARIANT_ID = parseInt(perso.getAttribute('data-supplement-variant') || '0', 10) || 0;
  /* Variants du kit pré-chargés en Liquid (évite le fetch /products du kit) */
  var KIT_VARIANTS = [];
  try { KIT_VARIANTS = JSON.parse(perso.getAttribute('data-kit-variants') || '[]'); } catch (e) { KIT_VARIANTS = []; }

  /* ─── Type d'ongles (sur-mesure / prêt-à-porter) ─── */
  var typesWrap = perso.querySelector('[data-perso-types]');
  if (typesWrap) {
    /* Init : applique le data-active-type basé sur la valeur cochée par défaut */
    var initialActive = typesWrap.querySelector('.cds-pp__perso-type.is-active');
    if (initialActive) perso.setAttribute('data-active-type', initialActive.getAttribute('data-type-key') || 'type1');

    typesWrap.addEventListener('change', function(e) {
      typesWrap.querySelectorAll('.cds-pp__perso-type').forEach(function(t){ t.classList.remove('is-active'); });
      var active = e.target.closest('.cds-pp__perso-type');
      if (active) {
        active.classList.add('is-active');
        perso.setAttribute('data-active-type', active.getAttribute('data-type-key') || 'type1');
      }
      sync();
    });
  }

  /* ─── Shape → conditional lengths + image swap ─── */
  var shapesWrap = perso.querySelector('[data-perso-shapes]');
  var shapeLabel = perso.querySelector('[data-perso-shape-label]');
  var lengthsWrap = perso.querySelector('[data-perso-lengths]');
  var lengthLabel = perso.querySelector('[data-perso-length-label]');

  function updateLengths(shapeEl) {
    if (!shapeEl || !lengthsWrap) return;
    var avail = (shapeEl.getAttribute('data-shape-lengths') || '').split(',').map(function(s){return s.trim();}).filter(Boolean);
    var cards = lengthsWrap.querySelectorAll('[data-length-value]');
    var firstVisible = null;
    cards.forEach(function(card) {
      var val = card.getAttribute('data-length-value');
      var radio = card.querySelector('input[type="radio"]');
      if (avail.indexOf(val) !== -1) {
        card.style.display = '';
        if (!firstVisible) firstVisible = card;
      } else {
        card.style.display = 'none';
        card.classList.remove('is-active');
        if (radio) radio.checked = false;
      }
    });
    if (firstVisible) {
      cards.forEach(function(c){ c.classList.remove('is-active'); });
      firstVisible.classList.add('is-active');
      var r = firstVisible.querySelector('input[type="radio"]');
      if (r) r.checked = true;
      if (lengthLabel) lengthLabel.textContent = firstVisible.getAttribute('data-length-value');
    } else if (lengthLabel) {
      lengthLabel.textContent = '';
    }
  }

  if (shapesWrap) {
    shapesWrap.addEventListener('change', function(e) {
      shapesWrap.querySelectorAll('.cds-pp__perso-shape').forEach(function(s){ s.classList.remove('is-active'); });
      var active = e.target.closest('.cds-pp__perso-shape');
      if (active) active.classList.add('is-active');
      if (shapeLabel) shapeLabel.textContent = e.target.value;
      updateLengths(active);
      if (typeof showKitError === 'function') showKitError(false); /* lève l'erreur « choisis ta forme » */
      sync();
    });
    var first = shapesWrap.querySelector('.cds-pp__perso-shape.is-active');
    if (first) updateLengths(first);
  }
  if (lengthsWrap) {
    lengthsWrap.addEventListener('change', function(e) {
      lengthsWrap.querySelectorAll('.cds-pp__perso-length').forEach(function(c){ c.classList.remove('is-active'); });
      var c = e.target.closest('.cds-pp__perso-length');
      if (c) c.classList.add('is-active');
      if (lengthLabel) lengthLabel.textContent = e.target.value;
      if (typeof showKitError === 'function') showKitError(false); /* lève l'erreur « choisis ta longueur » */
      sync();
    });
  }

  /* ─── Mesures toggle ─── */
  var mesToggle = perso.querySelector('[data-perso-mesures-toggle]');
  var mesPanel = perso.querySelector('[data-perso-panel="mesures"]');
  var mesHint = perso.querySelector('[data-perso-mesures-hint]');
  if (mesToggle && mesPanel) {
    mesToggle.addEventListener('change', function(e) {
      mesToggle.querySelectorAll('.cds-pp__perso-pill').forEach(function(p){ p.classList.remove('is-active'); });
      e.target.closest('.cds-pp__perso-pill').classList.add('is-active');
      /* « Oui, j'en ai besoin » → un kit sera ajouté (pas de saisie mm) ;
         « Non, j'ai déjà mes mesures » → saisie des mesures, aucun kit. */
      var needsKit = (e.target.value || '').indexOf('Oui') === 0;
      if (needsKit) {
        mesPanel.classList.remove('is-visible');
        if (mesHint) mesHint.classList.remove('cds-pp__perso-hint--hidden');
      } else {
        mesPanel.classList.add('is-visible');
        if (mesHint) mesHint.classList.add('cds-pp__perso-hint--hidden');
      }
      if (typeof showKitError === 'function') showKitError(false);
      sync();
    });
  }

  /* ─── Lecture des valeurs ─── */
  function getRadio(field) {
    var el = perso.querySelector('[data-perso-field="' + field + '"]:checked');
    return el ? el.value : '';
  }
  function getInput(field) {
    var el = perso.querySelector('[data-perso-field="' + field + '"]');
    return el ? (el.value || '').trim() : '';
  }
  function compileMesures() {
    var fingers = ['pouce','index','majeur','annulaire','auriculaire'];
    function hand(prefix, label) {
      var parts = [];
      fingers.forEach(function(f) {
        var v = getInput(prefix + '_' + f);
        if (v) parts.push(f.charAt(0).toUpperCase() + f.slice(1) + ': ' + v);
      });
      return parts.length ? label + ' — ' + parts.join(', ') : '';
    }
    var g = hand('gauche', 'Main gauche');
    var d = hand('droite', 'Main droite');
    var out = []; if (g) out.push(g); if (d) out.push(d);
    return out.join(' / ');
  }

  /* ─── Injection product form via properties[] ─── */
  function findForm() {
    return section.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function setProp(form, name, value) {
    if (!form || !name) return;
    var input = form.querySelector('input[name="properties[' + name + ']"][data-perso-prop]');
    var hasValue = value && value.length > 0;
    if (hasValue) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.setAttribute('data-perso-prop', '');
        form.appendChild(input);
      }
      input.value = value;
    } else if (input) {
      input.remove();
    }
  }
  function getActiveType() {
    return perso.getAttribute('data-active-type') || '';
  }
  function isPretAPorter() {
    return getActiveType() === 'type2';
  }
  function sync() {
    var form = findForm();
    if (!form) return;
    var typeVal = getRadio('type');
    setProp(form, LABELS.type, typeVal);
    setProp(form, LABELS.couleur, getInput('couleur'));
    setProp(form, LABELS.forme, getRadio('forme'));
    setProp(form, LABELS.longueur, getRadio('longueur'));
    /* Mesures uniquement en mode sur-mesure (type1) */
    if (isPretAPorter()) {
      setProp(form, LABELS.mesures_connues, '');
      setProp(form, LABELS.mesures, '');
    } else {
      setProp(form, LABELS.mesures_connues, getRadio('mesures_connues'));
      setProp(form, LABELS.mesures, compileMesures());
    }
    setProp(form, LABELS.commentaire, getInput('commentaire'));
    /* Récap dynamique « (forme X · longueur Y) » dans l'info kit */
    if (kitRecapEl) {
      var rf = getRadio('forme'), rl = getRadio('longueur');
      kitRecapEl.textContent = (rf && rl) ? ' (forme ' + rf + ' · longueur ' + rl + ')' : '';
    }
  }

  /* ─── Validation du choix « kit de mesures » (obligatoire en sur-mesure : choix forcé) ─── */
  var kitError = perso.querySelector('[data-perso-kit-error]');
  var kitRecapEl = perso.querySelector('[data-perso-kit-recap]');
  function mesuresVisible() { return !!mesToggle && !isPretAPorter(); }
  function kitChoiceError() {
    if (!mesuresVisible()) return null;            /* prêt-à-porter / pas de question → rien à valider */
    var v = getRadio('mesures_connues');
    if (!v) return "Choisis si tu as besoin d'un kit de mesures.";
    if (v.indexOf('Oui') === 0 && !(getRadio('forme') && getRadio('longueur'))) {
      return 'Choisis ta forme et ta longueur pour préparer ton kit.';
    }
    return null;
  }
  function showKitError(arg) {
    if (!kitError) return;
    if (arg) {
      kitError.textContent = (typeof arg === 'string') ? arg : 'Choisis une option pour continuer.';
      kitError.removeAttribute('hidden');
      var grp = mesToggle && mesToggle.closest('[data-perso-mesures-group]');
      try { (grp || mesToggle).scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    } else {
      kitError.setAttribute('hidden', '');
    }
  }

  /* ─── Validation du champ couleur obligatoire (si présent) ─── */
  var colorInput = perso.querySelector('[data-perso-field="couleur"][data-perso-required]');
  var colorError = perso.querySelector('[data-perso-color-error]');
  function colorIsValid() {
    if (!colorInput) return true; /* pas de champ couleur → rien à valider */
    return (colorInput.value || '').trim().length > 0;
  }
  function showColorError(show) {
    if (!colorInput) return;
    colorInput.classList.toggle('is-invalid', show);
    if (colorError) { if (show) colorError.removeAttribute('hidden'); else colorError.setAttribute('hidden', ''); }
    if (show) {
      try { colorInput.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      try { colorInput.focus({ preventScroll: true }); } catch (e) { colorInput.focus(); }
    }
  }
  if (colorInput) {
    colorInput.addEventListener('input', function() {
      if (colorInput.classList.contains('is-invalid') && colorIsValid()) showColorError(false);
      sync();
    });
  }
  /* Badge "Voir les photos" → ouvre une MODAL galerie swipeable */
  var seePhotosBtn = perso.querySelector('[data-perso-seephotos]');
  var galleryModal = perso.querySelector('[data-perso-gallery-modal]');
  if (seePhotosBtn) {
    if (galleryModal) {
      var gTrack = galleryModal.querySelector('[data-perso-gallery-track]');
      var gPrev = galleryModal.querySelector('[data-perso-gallery-prev]');
      var gNext = galleryModal.querySelector('[data-perso-gallery-next]');
      var gCounter = galleryModal.querySelector('[data-perso-gallery-counter]');
      var gSlides = gTrack ? gTrack.querySelectorAll('.cds-pp__gallery-slide') : [];

      function gStep() {
        var first = gTrack && gTrack.querySelector('.cds-pp__gallery-slide');
        return first ? first.getBoundingClientRect().width : (gTrack ? gTrack.clientWidth : 0);
      }
      function gCurrentIndex() {
        if (!gTrack) return 0;
        var w = gStep();
        return w ? Math.round(gTrack.scrollLeft / w) : 0;
      }
      function gUpdate() {
        if (!gTrack) return;
        var idx = gCurrentIndex();
        var max = gTrack.scrollWidth - gTrack.clientWidth;
        if (gPrev) gPrev.disabled = gTrack.scrollLeft <= 2;
        if (gNext) gNext.disabled = gTrack.scrollLeft >= max - 2;
        if (gCounter) gCounter.textContent = (idx + 1) + ' / ' + gSlides.length;
      }
      if (gPrev) gPrev.addEventListener('click', function() { gTrack.scrollBy({ left: -gStep(), behavior: 'smooth' }); });
      if (gNext) gNext.addEventListener('click', function() { gTrack.scrollBy({ left: gStep(), behavior: 'smooth' }); });
      if (gTrack) gTrack.addEventListener('scroll', function() { window.requestAnimationFrame(gUpdate); }, { passive: true });

      function openGallery() {
        try { if (typeof galleryModal.showModal === 'function' && !galleryModal.open) galleryModal.showModal(); else galleryModal.setAttribute('open',''); }
        catch (e) { galleryModal.setAttribute('open',''); }
        document.body.style.overflow = 'hidden';
        /* reset au début + maj compteur */
        if (gTrack) gTrack.scrollLeft = 0;
        setTimeout(gUpdate, 30);
      }
      function closeGallery() {
        try { if (typeof galleryModal.close === 'function' && galleryModal.open) galleryModal.close(); else galleryModal.removeAttribute('open'); }
        catch (e) { galleryModal.removeAttribute('open'); }
        document.body.style.overflow = '';
      }
      seePhotosBtn.addEventListener('click', openGallery);
      galleryModal.querySelectorAll('[data-perso-gallery-close]').forEach(function(el) {
        el.addEventListener('click', function(e) { e.preventDefault(); closeGallery(); });
      });
      /* clic sur le backdrop (hors viewport) ferme */
      galleryModal.addEventListener('click', function(e) { if (e.target === galleryModal) closeGallery(); });
      galleryModal.addEventListener('cancel', function(e) { e.preventDefault(); closeGallery(); });
      galleryModal.addEventListener('close', function() { document.body.style.overflow = ''; });
      /* flèches clavier */
      galleryModal.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft' && gPrev) gPrev.click();
        else if (e.key === 'ArrowRight' && gNext) gNext.click();
      });
    } else {
      /* Fallback : pas de modal galerie → scroll vers la galerie de la page */
      seePhotosBtn.addEventListener('click', function() {
        var gallery = section.querySelector('.cds-pp__gallery, .cds-pp__carousel, .cds-pp__media-main, .cds-pp__grid');
        if (gallery) { try { gallery.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { gallery.scrollIntoView(); } }
      });
    }
  }

  perso.addEventListener('change', sync);
  perso.addEventListener('input', sync);

  function initSync() {
    if (findForm()) { sync(); }
    else { setTimeout(initSync, 200); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSync);
  else initSync();

  /* Installe tôt le hook de blocage du drawer + retries pour capturer le <dialog>
     interne qui peut être créé tardivement par Horizon. */
  if (typeof patchDrawerOpen === 'function') {
    [0, 300, 800, 1500, 3000].forEach(function(d) {
      setTimeout(function(){ try { patchDrawerOpen(); } catch (e) {} }, d);
    });
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail.sectionId === _sid) sync();
    });
  }

  /* ═══ AUTO-ADD (kit de mesures + supplément prêt-à-porter) ═══ */
  /* IMPORTANT : ce bloc s'exécute TOUJOURS (kit OU supplément).
     La modal n'existe que si auto_add_kit est activé, mais le supplément
     doit fonctionner indépendamment → pas de garde `if (kitModal)`. */
  var kitModal = perso.querySelector('[data-perso-kit-modal]');
  var kitHandle = perso.getAttribute('data-kit-handle') || '';
  var kitProductCache = null;

  var _kitModalActive = false;   /* true tant que la modal doit rester affichée */
  var _kitModalTimers = [];      /* timers de ré-assurance top-layer (à annuler à la fermeture) */

  function closeCartDrawer() {
    try {
      var dc = document.querySelector('cart-drawer-component');
      if (!dc) return;
      var dlg = dc.querySelector('dialog');
      if (dlg && dlg.open && typeof dlg.close === 'function') { dlg.close(); return; }
      if (typeof dc.close === 'function') dc.close();
      else if (typeof dc.closeDialog === 'function') dc.closeDialog();
    } catch (e) {}
  }
  function openCartDrawer() {
    try {
      var dc = document.querySelector('cart-drawer-component');
      if (!dc) return;
      if (typeof dc.open === 'function') dc.open();
      else if (typeof dc.showDialog === 'function') dc.showDialog();
    } catch (e) {}
  }
  /* Patch le drawer pour POUVOIR bloquer son ouverture (mode kit) → zéro flash.
     On patche À LA FOIS le composant (open/showDialog) ET son <dialog> interne
     (showModal/show) — c'est ce dernier qui ouvre réellement le top-layer. */
  function patchDrawerOpen() {
    var dc = document.querySelector('cart-drawer-component');
    if (!dc) return;
    /* 1) composant */
    if (!dc._cdsDrawerPatched) {
      dc._cdsDrawerPatched = true;
      ['open', 'showDialog'].forEach(function(m) {
        if (typeof dc[m] === 'function') {
          var orig = dc[m].bind(dc);
          dc[m] = function() {
            if (window._cdsSuppressDrawer) return;
            return orig.apply(dc, arguments);
          };
        }
      });
    }
    /* 2) <dialog> interne — la vraie source de l'ouverture top-layer */
    var dlg = dc.querySelector('dialog');
    if (dlg && !dlg._cdsDialogPatched) {
      dlg._cdsDialogPatched = true;
      ['showModal', 'show'].forEach(function(m) {
        if (typeof dlg[m] === 'function') {
          var orig = dlg[m].bind(dlg);
          dlg[m] = function() {
            if (window._cdsSuppressDrawer) return;
            return orig.apply(dlg, arguments);
          };
        }
      });
    }
  }
  function openKitDialogOnTop() {
    if (!kitModal || !_kitModalActive) return; /* la modal a été fermée → on ne rouvre rien */
    try {
      if (typeof kitModal.showModal === 'function') { if (!kitModal.open) kitModal.showModal(); }
      else { kitModal.setAttribute('open', ''); }
    } catch (e) { kitModal.setAttribute('open', ''); }
    document.body.style.overflow = 'hidden';
  }
  /* Ré-assurance : si le drawer s'est ouvert malgré le patch, on le FERME.
     Notre modal (déjà ouverte dans le top-layer, juste en dessous) redevient
     alors le dialog du dessus — SANS toucher à notre modal (pas de close/reshow
     qui déclencherait le handler 'close'). */
  function reassureModalOnTop() {
    if (!_kitModalActive || !kitModal) return;
    var dc = document.querySelector('cart-drawer-component');
    var dlg = dc && dc.querySelector('dialog');
    if (dlg && dlg.open) {
      closeCartDrawer();
      if (!kitModal.open) openKitDialogOnTop(); /* sécurité si la modal s'était fermée */
    }
  }
  function showModal() {
    if (!kitModal) return; /* pas de modal configurée → on ne montre rien */
    _kitModalActive = true;
    patchDrawerOpen();      /* s'assure que les hooks sont posés */
    closeCartDrawer();
    openKitDialogOnTop();
    /* Filet : si le drawer s'ouvre quand même, on le neutralise (rare grâce au patch) */
    _kitModalTimers.forEach(clearTimeout);
    _kitModalTimers = [
      setTimeout(reassureModalOnTop, 120),
      setTimeout(reassureModalOnTop, 400)
    ];
  }
  function hideModal() {
    if (!kitModal) return;
    /* Stoppe immédiatement les ré-assurances (sinon elles re-fermeraient le drawer) */
    _kitModalActive = false;
    _kitModalTimers.forEach(clearTimeout);
    _kitModalTimers = [];
    try {
      if (typeof kitModal.close === 'function' && kitModal.open) kitModal.close();
      else kitModal.removeAttribute('open');
    } catch (e) { kitModal.removeAttribute('open'); }
    /* le reste (restore auto-open + ouverture du drawer) est géré par l'event 'close' */
  }
  if (kitModal) {
    /* Boutons de fermeture (croix + CTA) */
    perso.querySelectorAll('[data-perso-kit-modal-close]').forEach(function(el) {
      el.addEventListener('click', function(e) { e.preventDefault(); hideModal(); });
    });
    /* Clic sur le backdrop du <dialog> (zone hors contenu) → ferme */
    kitModal.addEventListener('click', function(e) {
      if (e.target === kitModal) hideModal();
    });
    /* Escape natif */
    kitModal.addEventListener('cancel', function(e) { e.preventDefault(); hideModal(); });
    /* À CHAQUE fermeture (croix, CTA, Escape, backdrop) : lève le blocage du drawer
       ET l'ouvre pour montrer le set + le kit ajoutés. */
    kitModal.addEventListener('close', function() {
      _kitModalActive = false;
      _kitModalTimers.forEach(clearTimeout);
      _kitModalTimers = [];
      document.body.style.overflow = '';
      /* Lève le blocage d'ouverture du drawer */
      window._cdsSuppressDrawer = false;
      var dc = document.querySelector('cart-drawer-component');
      if (dc && dc.getAttribute('data-cds-restore-autoopen') === '1') {
        dc.setAttribute('auto-open', '');
        dc.removeAttribute('data-cds-restore-autoopen');
      }
      /* Ouvre le drawer après la fermeture de la modal (petit délai pour laisser le top-layer se libérer) */
      setTimeout(openCartDrawer, 80);
    });
  }

    function shouldAutoAddKit() {
      /* Aucun kit configuré → rien à ajouter */
      if (!kitHandle && (!KIT_VARIANTS || !KIT_VARIANTS.length)) return false;
      /* En mode "Prêt-à-porter" → jamais de kit */
      if (isPretAPorter()) return false;
      var mesValue = getRadio('mesures_connues');
      /* Opt-in EXPLICITE : on n'ajoute le kit que si la cliente a coché « Oui, j'en ai besoin ». */
      if (!mesValue || mesValue.indexOf('Oui') !== 0) return false;
      var forme = getRadio('forme');
      var longueur = getRadio('longueur');
      return forme && longueur;
    }

    function shouldAutoAddSupplement() {
      return isPretAPorter() && SUPPLEMENT_HANDLE;
    }
    async function fetchSupplementProduct() {
      if (supplementCache) return supplementCache;
      if (!SUPPLEMENT_HANDLE) return null;
      try {
        var res = await fetch('/products/' + SUPPLEMENT_HANDLE + '.js');
        if (!res.ok) throw new Error('Supplement product not found: ' + SUPPLEMENT_HANDLE);
        supplementCache = await res.json();
        return supplementCache;
      } catch (err) {
        console.warn('[CDS perso] Impossible de charger le supplément "' + SUPPLEMENT_HANDLE + '":', err);
        return null;
      }
    }
    function findFirstAvailableVariant(product) {
      if (!product || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) return product.variants[i];
      }
      return product.variants[0] || null;
    }

    async function fetchKitProduct() {
      if (kitProductCache) return kitProductCache;
      try {
        var res = await fetch('/products/' + kitHandle + '.js');
        if (!res.ok) throw new Error('Kit product not found: ' + kitHandle);
        kitProductCache = await res.json();
        return kitProductCache;
      } catch (err) {
        console.warn('[CDS perso] Impossible de charger le kit "' + kitHandle + '":', err);
        return null;
      }
    }

    function findKitVariant(product, forme, longueur) {
      if (!product || !product.variants) return null;
      function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
      var f = norm(forme);
      var l = norm(longueur);
      var combo = norm(f + ' ' + l);   /* ex: "amande s" — valeur d'option COMBINÉE */

      /* 1) Option/titre combiné exact "Amande S" (cas du produit kit : 1 option "Forme et longueur") */
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var opts = (v.options || []).map(norm);
        var title = norm(v.title);
        if (opts.indexOf(combo) !== -1 || title === combo) return v;
      }
      /* 2) Deux options séparées Forme + Longueur (cas alternatif) */
      for (var j = 0; j < product.variants.length; j++) {
        var v2 = product.variants[j];
        var opts2 = (v2.options || []).map(norm);
        if (opts2.indexOf(f) !== -1 && opts2.indexOf(l) !== -1) return v2;
      }
      /* 3) Fallback souple : le titre contient forme ET longueur (mots) */
      for (var k = 0; k < product.variants.length; k++) {
        var v3 = product.variants[k];
        var t3 = norm(v3.title);
        var optsJoined = ((v3.options || []).map(norm)).join(' ');
        var hay = (t3 + ' ' + optsJoined);
        /* match longueur en mot entier pour éviter S ⊂ "Stiletto" */
        var lRe = new RegExp('(^|\\s)' + l.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|\\s)');
        if (hay.indexOf(f) !== -1 && lRe.test(hay)) return v3;
      }
      return null;
    }

    /* ════════════════════════════════════════════════════════════
       STRATÉGIE : monkey-patch de window.fetch (+ XHR).
       Horizon ajoute le produit principal via fetch('/cart/add')
       sans déclencher d'event 'submit' fiable. On intercepte donc
       DIRECTEMENT tout POST /cart/add : dès qu'il réussit ET qu'un
       add-on est attendu, on ajoute le kit/supplément derrière.
       ════════════════════════════════════════════════════════════ */
    var pendingAutoAdd = false;   /* un add-on est attendu (set au clic ATC) */
    var inProcess = false;        /* anti-réentrance */
    var _selfAdd = false;         /* ignore nos propres appels /cart/add */
    var bundleGroupId = '';       /* ID de groupe partagé parent ↔ add-on */
    var pendingKitLabel = '';     /* clé forme+longueur GELÉE au clic ATC (anti-divergence si le client change le radio pendant l'async) */
    var pendingForme = '';        /* forme gelée au clic (→ résolution variante kit) */
    var pendingLongueur = '';     /* longueur gelée au clic (→ résolution variante kit) */

    function genBundleId() {
      return 'cds-' + (Date.now()) + '-' + Math.random().toString(36).substr(2, 6);
    }

    /* Libellé normalisé forme+longueur — clé de mutualisation du kit (1 kit par forme+longueur) */
    function kitFormLabel() {
      return (getRadio('forme') + ' ' + getRadio('longueur')).toLowerCase().replace(/\s+/g, ' ').trim();
    }
    /* Un kit mutualisé pour cette forme+longueur est-il déjà dans le panier ? */
    async function kitAutoExists(label) {
      try {
        var cart = await window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        return ((cart && cart.items) || []).some(function (it) { return ((it.properties || {})['_kit_auto'] || '') === label; });
      } catch (e) { return false; }
    }
    /* Ajoute le kit en LIGNE AUTONOME (pas un enfant de bundle), taggé par forme+longueur */
    async function addKitStandalone(variantId, label) {
      try {
        var res = await window.fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_kit_auto': label } }] })
        });
        return res.ok;
      } catch (e) { return false; }
    }

    function markPending() {
      if (shouldAutoAddKit() || shouldAutoAddSupplement()) {
        var form = findForm();
        if (shouldAutoAddKit()) {
          /* Kit MUTUALISÉ : pas de bundle. On tague le produit avec la forme+longueur
             du kit dont il a besoin (_kit_needed). Le kit est ajouté en LIGNE AUTONOME
             (1 seul par forme+longueur) ; la cascade le retire quand plus aucun produit
             de cette forme ne reste dans le panier. */
          /* Snapshot GELÉ au clic : forme, longueur et clé — tous issus du même instant,
             pour que la variante kit ET la clé de mutualisation restent cohérentes même
             si le client modifie le radio pendant le POST asynchrone. */
          pendingForme = getRadio('forme');
          pendingLongueur = getRadio('longueur');
          pendingKitLabel = kitFormLabel();
          if (form) {
            setProp(form, '_kit_needed', pendingKitLabel);
            setProp(form, '_bundle_group', '');
            setProp(form, '_bundle_role', '');
          }
          bundleGroupId = '';
        } else {
          /* Supplément prêt-à-porter : bundle classique (1 enfant par produit). */
          pendingForme = ''; pendingLongueur = ''; pendingKitLabel = '';
          bundleGroupId = genBundleId();
          if (form) {
            setProp(form, '_bundle_group', bundleGroupId);
            setProp(form, '_bundle_role', 'parent');
            setProp(form, '_kit_needed', '');
          }
        }
        sync(); /* s'assure que les autres properties sont à jour avant l'ajout */
        pendingAutoAdd = true;
        /* Mode sur-mesure (kit) : on BLOQUE l'ouverture du cart drawer (zéro flash),
           c'est la modal "3 étapes" qui prend le relais. (En prêt-à-porter on
           laisse le drawer s'ouvrir normalement avec le supplément.) */
        if (shouldAutoAddKit()) {
          patchDrawerOpen();              /* installe le hook si pas déjà fait */
          window._cdsSuppressDrawer = true;  /* neutralise open()/showDialog() */
        } else {
          window._cdsSuppressDrawer = false;
        }
        setTimeout(function(){
          pendingAutoAdd = false;
          /* garde-fou : si la modal ne s'est jamais affichée, on débloque le drawer */
          if (!_kitModalActive) window._cdsSuppressDrawer = false;
        }, 15000);
      } else {
        pendingAutoAdd = false;
        pendingForme = ''; pendingLongueur = ''; pendingKitLabel = '';
        /* Pas d'add-on → on retire les properties bundle/kit du form (s'il y en avait) */
        var form2 = findForm();
        if (form2) {
          setProp(form2, '_bundle_group', '');
          setProp(form2, '_bundle_role', '');
          setProp(form2, '_kit_needed', '');
        }
      }
    }

    /* Capture le clic ATC par DÉLÉGATION sur document (capture phase).
       → survit aux re-renders du form par Horizon (après suppression panier, etc.)
       → se déclenche à CHAQUE ajout, pas seulement le premier. */
    function attachClickCapture() {
      if (perso._cdsClickDelegated) return;
      perso._cdsClickDelegated = true;
      var onAtcInteract = function(e) {
        var btn = e.target.closest('button[type="submit"], input[type="submit"], [name="add"], [data-add-to-cart], .product-form__submit, .cds-pp__atc');
        if (!btn) return;
        /* le bouton doit appartenir à un form d'ajout panier */
        if (!btn.closest('form[action*="/cart/add"]')) return;
        /* Validation : champ couleur obligatoire → bloque l'ajout si vide */
        if (!colorIsValid()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showColorError(true);
          return;
        }
        /* Validation : choix « kit de mesures » obligatoire (choix forcé en sur-mesure) */
        var kitErr = kitChoiceError();
        if (kitErr) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showKitError(kitErr);
          return;
        }
        markPending();
      };
      document.addEventListener('click', onAtcInteract, { capture: true });
      document.addEventListener('submit', function(e) {
        if (!(e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]'))) return;
        if (!colorIsValid()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showColorError(true);
          return;
        }
        var kitErr2 = kitChoiceError();
        if (kitErr2) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showKitError(kitErr2);
          return;
        }
        markPending();
      }, { capture: true });
    }

    /* ─── Monkey-patch window.fetch ─── */
    if (!window._cdsFetchPatched) {
      window._cdsFetchPatched = true;
      var _origFetch = window.fetch;
      window.fetch = function(input, init) {
        var url = '';
        try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch(e) {}
        var method = 'GET';
        try { method = (init && init.method) || (input && input.method) || 'GET'; } catch(e) {}
        var isAdd = /\/cart\/add(\.js)?($|\?)/.test(url) && String(method).toUpperCase() === 'POST';
        var p = _origFetch.apply(this, arguments);
        if (isAdd && !window._cdsSelfAdd) {
          p.then(function(res) {
            if (res && res.ok && window._cdsPendingFns) {
              window._cdsPendingFns.forEach(function(fn) { try { fn(); } catch(e) {} });
            }
          }).catch(function(){});
        }
        return p;
      };
      /* XHR aussi (au cas où un script legacy utilise XMLHttpRequest) */
      var _origOpen = XMLHttpRequest.prototype.open;
      var _origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(method, url) {
        try { this._cdsIsAdd = /\/cart\/add(\.js)?($|\?)/.test(url || '') && String(method||'').toUpperCase() === 'POST'; } catch(e) {}
        return _origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function() {
        if (this._cdsIsAdd && !window._cdsSelfAdd) {
          this.addEventListener('load', function() {
            if (this.status >= 200 && this.status < 300 && window._cdsPendingFns) {
              window._cdsPendingFns.forEach(function(fn) { try { fn(); } catch(e) {} });
            }
          });
        }
        return _origSend.apply(this, arguments);
      };
      window._cdsPendingFns = [];
    }
    /* Enregistre notre handler dans la liste globale (multi-sections safe) */
    window._cdsPendingFns.push(function() {
      if (pendingAutoAdd) processAddOns(); /* immédiat, plus de setTimeout */
    });

    /* ─── Ajoute le(s) add-on(s) après l'ajout du produit principal ─── */
    async function processAddOns() {
      if (!pendingAutoAdd || inProcess) return;
      inProcess = true;
      pendingAutoAdd = false;
      window._cdsSelfAdd = true; _selfAdd = true;

      var forme = pendingForme || getRadio('forme');
      var longueur = pendingLongueur || getRadio('longueur');
      try {
        if (shouldAutoAddSupplement()) {
          /* Variant pré-résolu en Liquid → ajout DIRECT, aucun fetch /products */
          var supId = SUPPLEMENT_VARIANT_ID;
          if (!supId) {
            /* Fallback : fetch produit (uniquement si pré-résolution a échoué) */
            var supProduct = await fetchSupplementProduct();
            var supVariant = supProduct ? findFirstAvailableVariant(supProduct) : null;
            supId = (supVariant && supVariant.available) ? supVariant.id : 0;
          }
          if (supId) {
            await addAddon(supId);
            console.log('[CDS perso] ✓ Supplément ajouté');
          } else { console.warn('[CDS perso] Aucun variant supplément disponible'); }
        }
        if (shouldAutoAddKit()) {
          /* Variants kit pré-chargés en Liquid → matching local, aucun fetch /products */
          var kitVariant = null;
          if (KIT_VARIANTS && KIT_VARIANTS.length) {
            kitVariant = findKitVariant({ variants: KIT_VARIANTS }, forme, longueur);
          }
          if (!kitVariant) {
            /* Fallback : fetch produit kit */
            var kitProduct = await fetchKitProduct();
            if (kitProduct) kitVariant = findKitVariant(kitProduct, forme, longueur);
          }
          if (kitVariant && kitVariant.available) {
            /* MUTUALISATION : on n'ajoute le kit que si aucun kit de cette forme+longueur
               n'est déjà dans le panier (sinon un seul kit couvre plusieurs modèles).
               On réutilise la clé GELÉE au clic (pendingKitLabel) pour qu'elle corresponde
               exactement au _kit_needed posé sur le produit, même si le radio a changé depuis. */
            var label = pendingKitLabel || kitFormLabel();
            var already = await kitAutoExists(label);
            if (already) {
              console.log('[CDS perso] Kit « ' + label + ' » déjà présent → mutualisé (non ré-ajouté)');
            } else {
              await addKitStandalone(kitVariant.id, label);
              console.log('[CDS perso] ✓ Kit ajouté (' + label + ')');
            }
          } else { console.warn('[CDS perso] Aucun variant kit pour ' + forme + ' / ' + longueur); }
          showModal();
        }
        await refreshCartUI();
      } catch (err) {
        console.error('[CDS perso] Erreur add-on:', err);
      } finally {
        window._cdsSelfAdd = false; _selfAdd = false;
        inProcess = false;
      }
    }

    /* Ajoute un variant comme ENFANT du bundle (flag _cdsSelfAdd actif → pas de ré-interception) */
    async function addAddon(variantId, extraProps) {
      try {
        var props = { '_bundle_group': bundleGroupId, '_bundle_role': 'child' };
        if (extraProps) { for (var k in extraProps) { if (extraProps.hasOwnProperty(k)) props[k] = extraProps[k]; } }
        var res = await window.fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
        });
        return res.ok;
      } catch (e) { return false; }
    }

    /* Rafraîchit le drawer/bulle panier — DISPATCH DIRECT (pas de fetch /cart.js préalable).
       Horizon : le composant cart-items écoute 'cart:update' et, comme l'event n'a PAS
       de sections HTML dans detail.data, il RE-FETCH lui-même SA section depuis le serveur
       (component-cart-items.js → sectionRenderer.renderSection). On laisse donc Horizon
       faire l'unique fetch nécessaire → plus rapide (1 round-trip au lieu de 2). */
    function refreshCartUI() {
      try {
        var evt = new CustomEvent('cart:update', {
          bubbles: true,
          detail: { sourceId: 'cds-perso-addon', data: { source: 'cds-perso-addon' } }
        });
        document.dispatchEvent(evt);
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate || 'cart-update', { source: 'cds-perso-addon' }); } catch(e) {}
        }
      } catch (e) {}
    }

    /* Init + retries (le form peut arriver tardivement / être remplacé) */
    attachClickCapture();
    var _ccTries = 0;
    (function retryClick() {
      attachClickCapture();
      if (!findForm() && _ccTries++ < 25) setTimeout(retryClick, 300);
    })();
    document.addEventListener('shopify:section:load', function() { setTimeout(attachClickCapture, 60); });
    document.addEventListener('shopify:variant:change', function() { setTimeout(attachClickCapture, 60); });

  }
  function boot() {
    document.querySelectorAll('[id^="cds-pp-"]').forEach(function (s) {
      if (s.querySelector('.cds-pp__perso') && !s._cdsPersoInit) { s._cdsPersoInit = true; initCdsPerso(s); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* re-init après navigation/section load (theme editor) */
  document.addEventListener('shopify:section:load', boot);
})();
